// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { getPortalAccountId, getPortalInstanceId } from './utils/metadata';

// TODO: export HubHttpClient from rpc-client-utils

const portalsHttpClient = createPortalsHttpClient({
  prefix: '/_hcms/portals-platform'
});
export default portalsHttpClient;
export function createPortalsHttpClient({
  prefix
}) {
  return {
    post: async (url, options) => {
      const requestUrl = new URL(url, window.location.origin);
      const resolvedPath = requestUrl.pathname;
      const clientInfo = {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId()
      };
      const proxiedUrl = `${prefix}${resolvedPath}`;
      const data = await fetch(proxiedUrl, {
        method: 'POST',
        credentials: 'include',
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, options === null || options === void 0 ? void 0 : options.headers, {
          'X-Hs-Membership-Csrf': Cookies.get('hs-membership-csrf')
        }),
        body: JSON.stringify(options !== null && options !== void 0 && options.data ? Object.assign({}, options.data, clientInfo) : Object.assign({}, clientInfo))
      });
      return data.json();
    },
    get: () => {
      throw new Error('Only POST requests are supported');
    },
    delete: () => {
      throw new Error('Only POST requests are supported');
    },
    put: () => {
      throw new Error('Only POST requests are supported');
    },
    patch: () => {
      throw new Error('Only POST requests are supported');
    }
  };
}